import { PermissionsEnum } from '@/auth/interfaces';
import { SaveUbicaciones } from '../../shared/saveUbicaciones';
import { useCheckPermissions } from '@/shared';

export interface CreateUbicacionesPageInterface {}

const CreateUbicacionesPage: React.FC<CreateUbicacionesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ubicacion);
  return <SaveUbicaciones titlePage="Crear Ubicaciones productos" />;
};

export default CreateUbicacionesPage;
